import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Lock(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 120 120">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.333 31.667v21.666h33.334V31.667C76.667 19.7 69.205 10 60 10c-9.205 0-16.667 9.7-16.667 21.667zM80 53.333h18a2 2 0 012 2v56a2 2 0 01-2 2H22a2 2 0 01-2-2v-56a2 2 0 012-2h18V30c0-12.887 8.954-23.333 20-23.333S80 17.113 80 30v23.333zM69.897 94.162c.203.58.101 1.218-.274 1.714s-.978.79-1.62.79H52.008a2.032 2.032 0 01-1.622-.79 1.828 1.828 0 01-.275-1.714l3.384-7.455c-3.041-2.466-4.237-6.426-3.035-10.053.987-3.063 3.551-5.433 6.797-6.28 4.51-1.24 9.317.683 11.545 4.616 2.228 3.933 1.274 8.813-2.292 11.719l3.386 7.453z"
      ></path>
    </IconSvg>
  );
}
